<div class="dashboard-container">
  <!-- Header -->
  <div class="dashboard-header">
    <h2>
      <mat-icon>analytics</mat-icon>
      Site Report Dashboard - {{ siteName }}
    </h2>
  </div>

  <!-- Summary Statistics Cards -->
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon">
        <mat-icon>event</mat-icon>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ summaryStats.totalEvents.toLocaleString() }}</div>
        <div class="stat-label">Total Events</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon">
        <mat-icon>videocam</mat-icon>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ summaryStats.uniqueCameras }}</div>
        <div class="stat-label">Active Cameras</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon">
        <mat-icon>category</mat-icon>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ summaryStats.uniqueEventTypes }}</div>
        <div class="stat-label">Event Types</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon">
        <mat-icon>calendar_today</mat-icon>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ summaryStats.averageEventsPerDay.toFixed(1) }}</div>
        <div class="stat-label">Avg Events/Day</div>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div class="loading-section" *ngIf="!chartsReady && eventData.length > 0">
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Preparing charts...</p>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="charts-section" *ngIf="chartsReady">
    <div class="chart-row">
      <!-- Event Type Distribution -->
      <div class="chart-card">
        <h3>Event Type Distribution</h3>
        <canvas #eventTypeCanvas></canvas>
      </div>

      <!-- Time Distribution -->
      <div class="chart-card">
        <h3>Events by Time of Day</h3>
        <canvas #timeDistributionCanvas></canvas>
      </div>
    </div>

    <div class="chart-row">
      <!-- Time Level Stacked Bar Chart -->
      <div class="chart-card full-width">
        <h3>Events by Time of Day with Level</h3>
        <canvas #timeLevelStackedCanvas></canvas>
      </div>
    </div>

    <div class="chart-row">
      <!-- Camera Distribution -->
      <div class="chart-card">
        <h3>Events by Camera</h3>
        <canvas #cameraDistributionCanvas></canvas>
      </div>

      <!-- Action Distribution Chart -->
      <div class="chart-card">
        <h3>Events by Action</h3>
        <canvas #actionDistributionCanvas></canvas>
      </div>
    </div>

    <div class="chart-row">
      <!-- Level Distribution Chart -->
      <div class="chart-card">
        <h3>Events by Current Level ID</h3>
        <canvas #levelDistributionCanvas></canvas>
      </div>
    </div>

    <div class="chart-row">
      <!-- Level Action Line Chart -->
      <div class="chart-card full-width">
        <h3>Events by Level and Action Over Time</h3>
        <canvas #levelActionLineCanvas></canvas>
      </div>
    </div>

    <div class="chart-row">
      <!-- Consolidated Level Actions Line Chart -->
      <div class="chart-card full-width">
        <h3>Consolidated Events by Level Over Time</h3>
        <canvas #consolidatedLevelCanvas></canvas>
      </div>
    </div>

    <div class="chart-row">
      <!-- Event Type Breakdown Table -->
      <div class="chart-card">
        <h3>Event Type Breakdown</h3>
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>Event Type</th>
                <th>Count</th>
                <th>Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of eventTypeBreakdown">
                <td>{{ item.type }}</td>
                <td>{{ item.count.toLocaleString() }}</td>
                <td>{{ item.percentage }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Pivot Tables Section -->
  <div class="pivot-section">
    <h3>Pivot Tables</h3>
    
    <!-- Camera vs Level Pivot -->
    <div class="pivot-card" *ngIf="cameraLevelPivot">
      <h4>Events by Camera and Current Level ID</h4>
      <div class="table-container">
        <table class="pivot-table">
          <thead>
            <tr>
              <th>Camera</th>
              <th *ngFor="let col of cameraLevelPivot.columnLabels">{{ col }}</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of cameraLevelPivot.rowLabels; let i = index">
              <td><strong>{{ row }}</strong></td>
              <td *ngFor="let col of cameraLevelPivot.columnLabels; let j = index">
                {{ cameraLevelPivot.data[i][j] }}
              </td>
              <td><strong>{{ cameraLevelPivot.totals.rows[i] }}</strong></td>
            </tr>
            <tr class="total-row">
              <td><strong>Total</strong></td>
              <td *ngFor="let total of cameraLevelPivot.totals.columns">
                <strong>{{ total }}</strong>
              </td>
              <td><strong>{{ cameraLevelPivot.totals.grand }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Camera vs Month Pivot -->
    <div class="pivot-card" *ngIf="cameraMonthPivot">
      <h4>Events by Camera and Month</h4>
      <div class="table-container">
        <table class="pivot-table">
          <thead>
            <tr>
              <th>Camera</th>
              <th *ngFor="let col of cameraMonthPivot.columnLabels">{{ col }}</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of cameraMonthPivot.rowLabels; let i = index">
              <td><strong>{{ row }}</strong></td>
              <td *ngFor="let col of cameraMonthPivot.columnLabels; let j = index">
                {{ cameraMonthPivot.data[i][j] }}
              </td>
              <td><strong>{{ cameraMonthPivot.totals.rows[i] }}</strong></td>
            </tr>
            <tr class="total-row">
              <td><strong>Total</strong></td>
              <td *ngFor="let total of cameraMonthPivot.totals.columns">
                <strong>{{ total }}</strong>
              </td>
              <td><strong>{{ cameraMonthPivot.totals.grand }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Time vs Month Pivot -->
    <div class="pivot-card" *ngIf="timeMonthPivot">
      <h4>Events by Time and Month</h4>
      <div class="table-container">
        <table class="pivot-table">
          <thead>
            <tr>
              <th>Time</th>
              <th *ngFor="let col of timeMonthPivot.columnLabels">{{ col }}</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of timeMonthPivot.rowLabels; let i = index">
              <td><strong>{{ row }}:00</strong></td>
              <td *ngFor="let col of timeMonthPivot.columnLabels; let j = index">
                {{ timeMonthPivot.data[i][j] }}
              </td>
              <td><strong>{{ timeMonthPivot.totals.rows[i] }}</strong></td>
            </tr>
            <tr class="total-row">
              <td><strong>Total</strong></td>
              <td *ngFor="let total of timeMonthPivot.totals.columns">
                <strong>{{ total }}</strong>
              </td>
              <td><strong>{{ timeMonthPivot.totals.grand }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
